var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header'),_c('div',{staticClass:"box"},[_c('h2',[_vm._v("Pesquisar")]),_c('NumberCases')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }